<template>
  <div class="verkauf">
    <div
      id="form-wrapper"
      data-tf-hide-headers
      style="width:100%;height:600px;"
      data-tf-inline-on-mobile
      data-tf-medium="snippet"
      
      :data-tf-hidden="'car_id='+carId"
      :data-tf-widget="widgetId"
      :data-tf-iframe-props="widgetTitle"
    ></div>
  </div>
</template>

<script>
import { currentPath } from "../services/helpers";

export default {
  computed: {
    id() {    
      return currentPath().verkaufId
    },
    carId() {
      return currentPath().carId
    },
    verkaufOrder: function() {
      return currentPath()["verkaufOrder"];
    },
    widgetId: function() {
      const ids = {
        '1': 'VNOhYeEU',
        '2': 'nBb2dQjG',
      }
      return ids[this.verkaufOrder];
    },
    widgetTitle: function() {
      const titles = {
        '1': 'PKW.de GW-Verkauf',
        '2': 'PKW.de GW-Verkauf 2/3',
      }
      return titles[this.verkaufOrder];
    },
  },
  mounted () {
    const header = document.querySelector('.main-header');
    const footer = document.querySelector('.main-footer');

    const elements = [header, footer];
    elements.forEach(el => el.style.display = 'block');
  }
};
</script>
<style lang="scss" scoped>
#form-wrapper {
  width: 100%;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
iframe {
  border-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Verkauf.vue